import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
/**
 * Chaque nouvelle page s'ouvre en haut (avant : elle gardait la position de la page précédente).
 * - Boutons Retour / Avance du navigateur : on ne touche à rien, le navigateur remet la position.
 * - Lien vers une partie d'une page (#ancre) : on va directement à cette partie.
 * - Changement de filtre dans la même page (?…) : pas de remontée.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType === "POP") return;
    if (hash) {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return null;
}
